<main *ngIf="!error; else errorMsg" class="container">
  <h1 class="title text-center">Todos os Cursos</h1>
  <app-barra-busca
    [eixos]="eixos"
    [componenteRef]="componenteRef"
    (inputEvent)="recebeuInput($event)"
  ></app-barra-busca>
  <section class="">
    <p *ngIf="totalResultados && realizouBusca" class="text-center results">
      Total de resultados encontrados {{ totalResultados }}
    </p>
    <p *ngIf="!totalResultados || (!totalResultados && realizouBusca)" class="text-center results">
      Desculpe, não encontramos nenhum resultado compatível com sua busca.
    </p>
    <ul>
      <li class="card bg-color-white contrast-border" *ngFor="let curso of cursos">
        <app-card
          [titulo]="curso.nome"
          [texto]="curso.perfilProfissional || curso.nomeCursoAtual"
          [id]="curso.id"
          [eixo]="curso.eixoTecnologicoCnctId || curso.eixoId"
          [eixos]="eixos"
          [cursoAtual]="curso.nomeCursoAtual"
          [eixoNome]="curso.eixoNome"
          [tipo]="curso.tipo"
        ></app-card>
      </li>
    </ul>
    <ng-container *ngIf="totalResultados > 0">
      <app-paginacao
        [paginaAtual]="paginaAtual"
        [totalPaginas]="totalPaginas"
        (mudouPagina)="onPaginaSelecionada($event)"
      ></app-paginacao>
    </ng-container>
  </section>
</main>

<ng-template #errorMsg> </ng-template>
